import Vue from 'vue'
import ProfileButton from '@/views/components/ProfileButton/index.vue'

// 全局注册ProfileButton组件
Vue.component('ProfileButton', ProfileButton)

// 导出组件以便在其他地方使用
export { ProfileButton }




